export const apis = [
    'openUrl',
    'getMeetingContext',
    'authorize',
    'onAuthorized',
    'launchAppInMeeting'
];